import {createContext} from 'react'

export const RedisDataContext = createContext(null) 